<template>
    <form class="kt-form" @submit.prevent="submit" id="psp_status_setting" v-if="setting_status == 'success'">
        <kt-form-row class="mb-4" v-if="statistics_status == 'success'">
            <kt-col>
                <kt-form-group>
                    <kt-form-label>
                        {{ $t('transaction_routing.psp_priorities') }}
                    </kt-form-label>
                    <div v-for="(psp, index) in statistics.current_psp_priorities" :key="index">
                        {{(index+1) + '. ' + $t('psp_list.' + psp) }}
                    </div>
                </kt-form-group>
            </kt-col>
        </kt-form-row>
        <kt-form-label>
            {{ $t('transaction_routing.active_psp') }}
        </kt-form-label>
        <kt-row>
            <kt-col lg="3" md="3" sm="3" :id="index" v-for="(psp, index) in psp_list" :key="index">
                <kt-form-group>
                    <div class="custom-control custom-checkbox" :id="psp + '_status-div'">
                        <input
                                type="checkbox"
                                class="custom-control-input"
                                :id="psp + '_status'"
                                :name="psp + '_status'"
                                v-model="setting.active_psp[psp]"
                        >
                        <label class="custom-control-label" :id="psp + '_status_label'" :for="psp + '_status'">
                            {{ $t('psp.' + psp) }}
                        </label>
                    </div>
                </kt-form-group>
            </kt-col>
        </kt-row>
        <kt-form-action class="mt-4">
            <button class="btn btn-md btn-success btn-wide" type="submit" id="psp_submit_btn">
                {{ $t('btn.edit') }}
            </button>
        </kt-form-action>
    </form>
</template>
<script>
    import $ from "jquery";
    import {i18n} from '@/plugins/i18n'
    import {KTApp} from "@/plugins/core/app";
    import {transactionRoutingService, marketingService} from "@/common/api.service";
    import {KTUtil} from "@/plugins/core/util";
    import {mapGetters} from "vuex";

    export default {
        name: "psp_list",
        props: {
            call_starshop: {
                required: false,
                type: Boolean,
                default: false
            },  
        },
        data() {
            return {
                active_psp : []
            }
        },
        methods: {
            submit(e) {
                let form = $('#psp_status_setting')
                let btn = $('#psp_submit_btn')
                if (this.setting.switch_status) {
                    this.setting.priority = 0
                }

                KTApp.progress(btn)
                let params = this.$store.getters['transactionRouting/setting']

                const setServiceSetting = this.call_starshop 
                    ? transactionRoutingService.setStarshopSetting 
                    : transactionRoutingService.setCoreSetting;

                setServiceSetting(params)
                    .then(response => {
                        this.showMsg(form, 'success', response.data.message);
                    })
                    .catch(({ response }) => {
                        let message = document.createElement('div');
                        message.innerHTML = response.data.message;

                        if (response.data.data) {
                            Object.values(response.data.data).forEach(errors => {
                                const li = document.createElement('li');
                                li.innerText = errors[0];
                                message.insertAdjacentElement('beforeend', li);
                            });
                        }

                        this.showMsg(form, 'danger', message);
                    })
                    .finally(() => {
                        KTUtil.scrollTop();
                        KTApp.unprogress(btn);
                    });
            }
        },
        computed: {
            ...mapGetters('transactionRouting', [
                'setting', 'setting_status', 'psp_list', 'statistics', 'statistics_status'
            ]),
        }
    }
</script>
<style scoped>
</style>